import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../lifechronicles/LifeChroniclesHome.css';

import {
  faCalendarDays,
  faCheckCircle,
  faUtensils,
  faCarrot,
  faStar,
  faSeedling,
  faDumbbell,
  faFaceSmile,
  faBreadSlice,
  faBullseye,
  faHospitalUser,
  faExclamationTriangle,
  faPrescriptionBottleMedical,
  faCameraRetro,
  faShoppingBasket,
  faFaceGrinHearts,
  faRulerCombined,
  faClipboardList,
  faGamepad,
  faTasks,
  faBrain,
  faSuitcase,
  faFolderOpen,
  faSyringe,
  faCar,
  faLeaf,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";

export const categories = [
  { to: "/calendar-list", icon: faCalendarDays, label: "Calendar", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/checklist-list", icon: faCheckCircle, label: "Checklist", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/cooking-list", icon: faUtensils, label: "Cooking", bgColor: "bg-orange-600", textColor: "text-white" },
  { to: "/events-list", icon: faStar, label: "Events", bgColor: "bg-purple-600", textColor: "text-white" },
  { to: "/experience-list", icon: faSeedling, label: "Experience", bgColor: "bg-indigo-700", textColor: "text-white" },
  { to: "/feelings-list", icon: faFaceSmile, label: "Feelings", bgColor: "bg-pink-600", textColor: "text-white" },
  { to: "/food-list", icon: faBreadSlice, label: "Food", bgColor: "bg-yellow-700", textColor: "text-white" },
  { to: "/goals-list", icon: faBullseye, label: "Goals", bgColor: "bg-teal-700", textColor: "text-white" },
  { to: "/issues-list", icon: faExclamationTriangle, label: "Issues", bgColor: "bg-red-700", textColor: "text-white" },
  { to: "/monthly-essentials-plan-list", icon: faShoppingBasket, label: "Monthly Essentials Plan", bgColor: "bg-yellow-700", textColor: "text-white" },
  { to: "/mood-list", icon: faFaceGrinHearts, label: "Mood", bgColor: "bg-yellow-400", textColor: "text-red" },
  { to: "/planner-list", icon: faClipboardList, label: "Planner", bgColor: "bg-teal-500", textColor: "text-white" },
  { to: "/play-sports-list", icon: faGamepad, label: "Play / Sports", bgColor: "bg-purple-800", textColor: "text-white" },

  { to: "/entertainment-list", icon: faGamepad, label: "Entertainment", bgColor: "bg-purple-800", textColor: "text-white" },
  { to: "/tasks-list", icon: faTasks, label: "Tasks", bgColor: "bg-gray-700", textColor: "text-white" },
  { to: "/thoughts-list", icon: faBrain, label: "Thoughts", bgColor: "bg-blue-800", textColor: "text-white" },
  { to: "/todo-list", icon: faListCheck, label: "ToDo", bgColor: "bg-purple-500", textColor: "text-white" },
  { to: "/travels-list", icon: faSuitcase, label: "Travels", bgColor: "bg-yellow-800", textColor: "text-white" },
  { to: "/unspecified-list", icon: faFolderOpen, label: "Unspecified", bgColor: "bg-red-800", textColor: "text-white" },
  { to: "/visits-list", icon: faCar, label: "Visits", bgColor: "bg-red-900", textColor: "text-white" },

  { to: "/routine-diet-list", icon: faCarrot, label: "Diet Routine", bgColor: "bg-orange-500", textColor: "text-white" },
  { to: "/exercise-list", icon: faDumbbell, label: "Yoga/Exercise", bgColor: "bg-red-600", textColor: "text-white" },
  { to: "/illness-list", icon: faHospitalUser, label: "Illness", bgColor: "bg-teal-800", textColor: "text-white" },
  { to: "/medicine-list", icon: faPrescriptionBottleMedical, label: "Medicine", bgColor: "bg-teal-800", textColor: "text-white" },
  { to: "/meditation-list", icon: faLeaf, label: "Meditations", bgColor: "bg-indigo-800", textColor: "text-white" },
  { to: "/physicalgrowth-list", icon: faRulerCombined, label: "Physical Growth", bgColor: "bg-green-800", textColor: "text-white" },
  { to: "/vaccination-list", icon: faSyringe, label: "Vaccinations", bgColor: "bg-teal-600", textColor: "text-white" },

  { to: "/memories-list", icon: faCameraRetro, label: "Motherhood Memories", bgColor: "bg-purple-900", textColor: "text-white" },
];

// { to: "/myroutines-study", icon: faBookOpen, label: "Study Routine", bgColor: "bg-blue-500", textColor: "text-white" },
// { to: "/donation-list", icon: faHandHoldingHeart, label: "Donations", bgColor: "bg-yellow-600", textColor: "text-white" },
// { to: "/bequests-list", icon: faHeartSolid, label: "Bequests", bgColor: "bg-pink-600", textColor: "text-white" },
// { to: "/essentials-list", icon: faClipboardList, label: "Essentials", bgColor: "bg-gray-200", textColor: "text-gray-800" },
// { to: "/storage-list", icon: faFileArchive, label: "Storage", bgColor: "bg-gray-200", textColor: "text-gray-800" },
// { to: "/family-list", icon: faFaceSmile, label: "Family", bgColor: "bg-gray-200", textColor: "text-gray-800" },
// { to: "/friends-list", icon: faUsers, label: "Friends", bgColor: "bg-gray-200", textColor: "text-gray-800" },
// { to: "/favourite-list", icon: faHeartSolid, label: "Favorites", bgColor: "bg-gray-200", textColor: "text-gray-800" }


const SheEarnsMotherhoodHome = () => {
    const navigate = useNavigate();

    return (
        <div>
            <div className="flex flex-col min-h-[92vh] items-center py-2 px-4 bg-black border border-pink-400 h-auto mt-1 rounded-lg">
                <p className="text-lg lg:text-xl mb-1 text-yellow-200">Pregnancy / Motherhood Journey</p>
                <div className='flex flex-col flex-wrap justify-center gap-4 mt-2 text-sm'>
                    <div className="grid grid-cols-3 lg:grid-cols-8 gap-2">
                        {categories.map((category, index) => (
                            <Link 
                                key={index} 
                                to={category.to} 
                                className={`flex flex-col items-center p-2 rounded-lg ${category.bgColor} ${category.textColor} shadow-lg hover:shadow-2xl transition-shadow duration-300`}
                            >
                                <FontAwesomeIcon icon={category.icon} size="x" className="mb-2" />
                                <span className="text-m flex items-center justify-center text-center">{category.label}</span>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
            <footer className="bg-[#2a0f2f] border-t border-pink-800 text-pink-300 py-4">
                <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                    <div className="text-xs lg:text-sm">
                    © 2025 Think5Whys Global DeepTech Solutions.
                    </div>
                    <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                    <Link to="/about-us" className="text-white hover:text-pink-400">About</Link>
                    <Link to="/privacy-policy" className="text-white hover:text-pink-400">Privacy Policy</Link>
                    <Link to="/terms-of-use" className="text-white hover:text-pink-400">Terms of Use</Link>
                    <Link to="/contact-us" className="text-white hover:text-pink-400">Contact</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default SheEarnsMotherhoodHome;
